import { createIconComponent } from '../../factory/create-icon-component';

export const IdealBuyIcon = createIconComponent(
  'IdealBuyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50001 19.9999L3.50001 19.9999M21.5 19.9999L10.5 19.9999M3.5 12L21.5 12M18.5 4L21.5 4M3.5 4L14.5 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
